import { WithdrawModule } from '@/containers/WithdrawModule';

const PaymentsWithdrawPage = () => <WithdrawModule />;

export default PaymentsWithdrawPage;
